@if (!isModalMode && !inTabGroup) {
  <div class="card">
    @if (useStandardizedHeaderBar$ | async) {
      <ds-header-bar
        class="card-header"
        [title]="'label_workspace_details' | translate"
        [chips]="wayfindingChips$ | async"
      ></ds-header-bar>
    } @else {
      <div class="card-header">
        <h1>{{ 'label_workspace_details' | translate }}</h1>
      </div>
    }
    <div class="card-body">
      <ng-container *ngTemplateOutlet="workspaceForm"></ng-container>
    </div>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="workspaceForm"></ng-container>
}

<ng-template #workspaceForm>
  <form [formGroup]="form" [class]="!isModalMode ? 'row pane-container' : ''" (ngSubmit)="onSave()">
    <div [class]="!isModalMode ? 'col-12 col-xl-6' : ''">
      @if (!inTabGroup) {
        <div class="margin-bottom-md">{{ 'required_fields_label' | translate }}</div>
      }

      @if (isModalMode && saveError()) {
        <app-error-message [messageKey]="'error_while_saving_workspace' | translate" class="mb-3"></app-error-message>
      }

      <div [class]="!isModalMode ? 'mb-4' : 'margin-bottom'">
        @if (inTabGroup) {
          <ds-input [label]="'label_workspace_name' | translate" [required]="true" [errorState]="isFieldInvalid($workspace.name)">
            <input ds-input-field [formControlName]="$workspace.name" [maxlength]="CHAR_LIMITS[$workspace.name]" />
          </ds-input>
        } @else {
          <app-common-input
            [form]="form"
            [formValidationRequest$]="formValidationRequest"
            [context]="{
              label: 'label_workspace_name',
              field: $workspace.name,
              overrideErrors: {
                maxlength: 'upsert_workspace_name_max_length_error_label' | translate: CHAR_LIMITS[$workspace.name],
              },
            }"
          ></app-common-input>
          <app-form-field-char-count
            [field]="form.get($workspace.name)"
            [charLimit]="CHAR_LIMITS[$workspace.name]"
          ></app-form-field-char-count>
        }
      </div>

      <div [class]="!isModalMode ? 'mb-4' : 'margin-bottom'">
        @if (inTabGroup) {
          <ds-input
            [label]="'label_description' | translate"
            [required]="true"
            [errorState]="isFieldInvalid($workspace.description)"
          >
            <textarea
              ds-input-field
              [formControlName]="$workspace.description"
              [maxlength]="CHAR_LIMITS[$workspace.description]"
            ></textarea>
          </ds-input>
        } @else {
          <app-common-textarea
            [form]="form"
            [formValidationRequest$]="formValidationRequest"
            [context]="{
              label: 'label_description',
              field: $workspace.description,
              placeholder: '',
            }"
          ></app-common-textarea>
          <app-form-field-char-count
            [field]="form.get($workspace.description)"
            [charLimit]="CHAR_LIMITS[$workspace.description]"
          ></app-form-field-char-count>
        }
      </div>

      <div [class]="!isModalMode ? 'margin-top-lg' : ''" class="d-flex flex-row gap-2">
        <button type="submit" class="btn btn-primary" data-test-id="save-button">
          {{ 'form_save' | translate }}
        </button>
        @if (inTabGroup) {
          <button type="button" class="btn btn-link" (click)="onDiscardChanges()" data-test-id="discard-changes-button">
            {{ 'discard_changes' | translate }}
          </button>
        } @else {
          <button type="button" class="btn btn-outline-primary" (click)="onCancel()" data-test-id="cancel-button">
            {{ 'form_cancel' | translate }}
          </button>
        }
      </div>
    </div>
  </form>
</ng-template>
